import {Box, Typography} from '@viptech/react-components'
import centeredPhotoExample from 'src/images/centeredPhotoExample.svg'
import goodDistanceExample from 'src/images/goodDistanceExample.svg'
import NoAccessoriesExample from 'src/images/NoAccessoriesExample.svg'

export const InfoFacialRecognition = () => {
  return (
    <Box display='flex' flex={1} justifyContent='space-evenly' width='100%'>
      <Box width='150px' display='flex' justifyContent='center' rowGap='8px' direction='column' align='center'>
        <Box width='132px' height='132px' border='1px solid #8E8E8E' display='flex' align='flex-end' justifyContent='center'>
          <img src={centeredPhotoExample} alt='Centered' />
        </Box>
        <Typography variant='label' size='12px' textAlign='center'>
          Certifique-se de que a face está bem alinhada, e centralizada na imagem
        </Typography>
      </Box>
      <Box width='150px' display='flex' justifyContent='center' rowGap='8px' direction='column' align='center'>
        <Box width='132px' height='132px' border='1px solid #8E8E8E' display='flex' align='flex-end' justifyContent='center'>
          <img src={goodDistanceExample} alt='Good distance' />
        </Box>
        <Typography variant='label' size='12px' textAlign='center'>
          Verifique se a face esta em uma boa distância e com uma boa resolução
        </Typography>
      </Box>
      <Box width='180px' display='flex' justifyContent='center' rowGap='8px' direction='column' align='center'>
        <Box width='132px' height='132px' border='1px solid #8E8E8E' display='flex' align='center' justifyContent='center'>
          <img src={NoAccessoriesExample} alt='No accessories' />
        </Box>
        <Typography variant='label' size='12px' textAlign='center'>
          Evite imagens com acessórios no rosto que dificulte a visualização da face.
        </Typography>
      </Box>
    </Box>
  )
}
